export const fieldNames = {
  CUSTOMER_NUMBER: 'customerNumber',
  SUM: 'sum',
  EMAIL: 'custEmail',
  ADDRESS: 'custAddr',
  DETAILS: 'orderDetails',
  CITY: 'city',
}